var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',[_c('span',[_vm._v(_vm._s(_vm.tourInfo.share_title))])]),_vm._v(" "),_c('div',{staticClass:"main"},_vm._l((_vm.erjiTourList),function(v,i){return _c('dl',{key:i},[_c('dt',[_c('img',{attrs:{"src":v.icon,"alt":""}})]),_vm._v(" "),_c('dd',[_vm._v("\n                "+_vm._s(v.name)+"\n            ")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-904fe038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/tourAll.vue
// module id = null
// module chunks = 